export function pretty(data) {
    return JSON.stringify(data, null, 4);
}
export function copyToClipboard(data) {
    navigator.clipboard.writeText(JSON.stringify(data, null, 4));
}
export function getTime() {
    return new Date().toLocaleTimeString();
}